import ControlledSelectField from 'views/components/common/Form/ReactForm/ControlledSelectField/ControlledSelectField';

export default ControlledSelectField;
